module.exports = __webpack_public_path__ + "img/20210202.5487ac34.gif";